import React, { useState } from "react";
import Icon from "./Icon";
import "../styles/QuoteForm.css";

const initialState = { name: "", email: "", phone: "", message: "" };

/*
 * Self-contained general-enquiry contact form. Lighter than QuoteForm —
 * name, email, phone, and a message. No backend wired up; drop a
 * fetch() call into handleSubmit when one is ready.
 */
export default function ContactForm() {
  const [form, setForm] = useState(initialState);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setError("Please fill in your name, email, and message.");
      return;
    }
    setError("");
    // Inline API call placeholder — wire up to your backend endpoint here.
    // fetch("https://users.mpdatahub.com/api/contact", { method: "POST", body: JSON.stringify(form) })
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="tp-quote-form tp-quote-form--success">
        <Icon name="checkCircle" size={44} />
        <h3>Thank you, {form.name.split(" ")[0]}!</h3>
        <p>We respond within 24–48 business hours. Our team will reach out to you shortly.</p>
        <button
          className="tp-btn tp-btn--outline"
          onClick={() => setForm(initialState) || setSubmitted(false)}
        >
          Send another message
        </button>
      </div>
    );
  }

  return (
    <form className="tp-quote-form" onSubmit={handleSubmit}>
      <h3 className="tp-quote-form__title">Send Us a Message</h3>
      <p className="tp-quote-form__sub">
        General questions, feedback, or press enquiries — we read every message.
      </p>

      <div className="tp-quote-form__grid">
        <label className="tp-quote-form__field">
          <span>Full Name</span>
          <input
            type="text"
            name="name"
            placeholder="Enter Full Name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </label>

        <label className="tp-quote-form__field">
          <span>Email Address</span>
          <input
            type="email"
            name="email"
            placeholder="Enter Email Address"
            value={form.email}
            onChange={handleChange}
            required
          />
        </label>

        <label className="tp-quote-form__field tp-quote-form__field--wide">
          <span>Phone / WhatsApp Number</span>
          <input
            type="tel"
            name="phone"
            placeholder="Enter Phone / WhatsApp Number (optional)"
            value={form.phone}
            onChange={handleChange}
          />
        </label>

        <label className="tp-quote-form__field tp-quote-form__field--wide">
          <span>Message</span>
          <textarea
            name="message"
            placeholder="How can we help?"
            value={form.message}
            onChange={handleChange}
            rows={4}
            required
          />
        </label>
      </div>

      {error && <p className="tp-quote-form__error">{error}</p>}

      <p className="tp-quote-form__note">We respond within 24 – 48 business hours.</p>

      <button type="submit" className="tp-btn tp-btn--primary">
        Send Message
        <Icon name="arrow" size={16} />
      </button>
    </form>
  );
}
